export enum TaskState {
    EMPTY = '1',
    WAITING = '2',
    VALIDATED = '3',
    REFUSED = '4',
    SYNC = '5'
}

export type Task = {
    operator_id: string | number;
    worksite_id: string | number;
    hours: string | number;
    type_id: string | number;
    id?: string | number;
    isNew?: boolean;
    state_id?: TaskState;
    reason?: string;
};

export type Day = {
    id: string;
    date: string;
    label: string;
    optional: boolean;
    personal_car: boolean;
    comment: string;
    tasks: Array<Task>;
    holidayLabel: string | null;
    canValidate?: boolean;
    holiday: {
        state_id: string | number;
        id: string | null;
    };
};

export type GetTimesheetsReportsPayload = undefined;

export type GetTimesheetsReportsResponse = Array<{
    label: string | number;
    days: Array<Day>;
}>;

export type GetTimesheetsTasksPayload = undefined;

export type GetTimesheetsTasksResponse = {
    id: string;
    label: string;
}[];

export type CreateTimesheetPayload = {
    id: string;
    personal_car: number;
    comment: string;
    tasks: Task[];
};

export type CreateTimesheetResponse = {
    id: string;
    date: string;
    label: string;
    optional: boolean;
    personal_car: boolean;
    comment: string;
    tasks: Task[];
    holidayLabel: string | null;
};

export type UpdateTimesheetPayload = CreateTimesheetPayload & {
    id: string;
    personal_car: number;
    comment: string;
    tasks: Array<Task & { id: string }>;
};

export type UpdateTimesheetResponse = CreateTimesheetResponse;

export type DeleteTaskPayload = {
    task_id: string;
};

export type DeleteTaskResponse = undefined;
